module.exports = __webpack_public_path__ + "static/media/coming-soon.3a144521.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/coming-soon.png
 ** module id = 1613
 ** module chunks = 0
 **/